// extracted by mini-css-extract-plugin
export var btn = "banner-module--btn--oy5Jm";
export var btnBlock = "banner-module--btnBlock--FuEh6";
export var container = "banner-module--container--04O1v";
export var hideMobBlock = "banner-module--hideMobBlock--pFJUT";
export var img = "banner-module--img--yoU-h";
export var mobBtn = "banner-module--mobBtn--FGTbF";
export var secondContainer = "banner-module--secondContainer--4AX4a";
export var section = "banner-module--section--3dm2v";
export var text = "banner-module--text--8RnJq";